import axios from 'axios';
import { LANGUAGES_URL } from '../../../../config';

export function getLanguages() {
	return axios.get(LANGUAGES_URL);
}
